import React, { useState, useRef, useEffect } from "react";
import "./LightPopup.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBolt } from "@fortawesome/free-solid-svg-icons";
import light from '../imagesHome/light.png';

const apiUrl = process.env.REACT_APP_API_URL;

const LightPopup = ({ streakCount }) => {
  const [open, setOpen] = useState(false);
  const popupRef = useRef(null);
  const [xp, setXp] = useState(0);

  // Fetch XP din API
  useEffect(() => {
    const fetchXP = async () => {
      try {
        const userRes = await fetch(`${apiUrl}/user`, {
          credentials: 'include',
        });
        const user = await userRes.json();
        
        const statsRes = await fetch(
          `${apiUrl}/user/${user.user_id}/stats`,
          { credentials: 'include' }
        );
        const stats = await statsRes.json();
        setXp(stats.xp ?? 0);
      } catch (error) {
        console.error('Error fetching XP:', error);
      }
    };
    fetchXP();
  }, []);

  // închide popup dacă dai click pe afară
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (popupRef.current && !popupRef.current.contains(event.target)) {
        setOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const popupContent = (
    <>
      {/* overlay gri */}
      <div className="light-overlay" onClick={() => setOpen(false)} />

      <div className={`light-popup ${open ? "open" : ""}`} ref={popupRef}>
        <button className="close-btn" onClick={() => setOpen(false)}>×</button>
        <div className="light-popup-content">
          <div className="light-number">{xp}</div>
           <img src={light} className="lesson-icon-numbers" />
          <h3>Ai {xp} XP</h3>
          <p>Continuă să înveți pentru a câștiga mai mult XP!</p>
          <button className="continue-btn">Continuă</button>
        </div>
      </div>
    </>
  );

  return (
    <div className="dimension-icons">
      <div className="metric-pill" onClick={() => setOpen(!open)}>
        <div className="metric-value color-size-numbers-light">{xp}</div>
        <img src={light} className="lesson-icon-numbers" />
      </div>

      {open && popupContent}
    </div>
  );
};

export default LightPopup;
